export enum AllowCreateInvoicesBy {
  AlllowCreateInvoicesBy_AllowToChooseOnCreation,
  AlllowCreateInvoicesBy_BudgetsOnly,
  AlllowCreateInvoicesBy_UserGroupOnly,
}
